import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { useForm } from 'react-hook-form';
import useWindowSize from 'hooks/use-windowSize';

import { ContactInfoService } from 'services/auth';
import { getAccessToken } from 'utils/authentication';
import { getErrorText } from 'utils/geterrortext';
import CartCountrySelect from 'components/pages/cart/CartCountrySelect';
import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './ContactForm.module.scss';
import TextInput from '@core/components/textinput/TextInput';



const ContactForm = ({ closeHandler, refetchHandler, toast, type = 'account' }) => {
    const [selectedCountry, setSelectedCountry] = useState();
    const { mobileDevice } = useWindowSize();
    const { data, isLoading } = useQuery(
        ['contact-info', getAccessToken()],
        () => ContactInfoService.GET(),
        {
            onSuccess: (data) => {
                setSelectedCountry(data.data.residential_country_iso);
            }
        }
    );
    const { mutate } = useMutation(ContactInfoService.PUT, {
        onSuccess: () => {
            refetchHandler();
            if (type === 'account')
                closeHandler();
        },
        onError: (err) => {
            toast(
                getErrorText(err),
                'alert'
            );
        }
    });

    const {
        register,
        setError,
        setValue,
        handleSubmit,
        control,
        formState: { errors },
        reset,
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        defaultValues: {}
    });

    useEffect(() => {
        if (data && data.data) {
            reset({ ...data.data });
        }
    }, [data, reset]);
    const submitForm = async (payload) => {
        try {
            payload.residential_country_iso = selectedCountry?.iso2;
            await mutate(payload);
        } catch (e) {
            console.log('error', e)
        }
    }
    return (
        <div className={classes.wrapper}>
            <h3>Tell Us About You</h3>
            {data && !isLoading && (
                <form onSubmit={handleSubmit(submitForm)} className="d-flex flex-column gap-3">
                    <CartCountrySelect
                        input={{
                            type: 'text',
                            label: 'Your country of residence',
                            name: 'residential_country_iso',
                            placeholder: 'Select your residential country',
                            id: 'residential_country_iso',

                        }}
                        errors={errors}
                        register={register}
                        selectedCountry={selectedCountry || data.data.residential_country_iso}
                        setSelectedCountry={setSelectedCountry}
                        mobileDevice={mobileDevice}
                        setValue={setValue}
                    />
                    <div className='mt-1'></div>
                    <TextInput
                        validation={{
                            required: false,
                            pattern: {
                                value: /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/,
                                message: 'Please enter a valid URL'
                            }
                        }}
                        input={{
                            type: 'text',
                            label: 'LinkedIn Profile',
                            name: 'linkedin_url',
                            placeholder: 'https://www.linkedin.com/in/profile',
                            id: `linkedin_url`
                        }}
                        errors={errors}
                        register={register}
                        hasErrorMsg={false}
                    />

                    <div className='d-flex justify-contetnt-center gap-5 px-md-5 px-0 mt-4'>
                        <ActionButton kind='blank' onClick={closeHandler}>
                            {type === 'account' ? 'Cancel' : 'Back'}
                        </ActionButton>
                        <ActionButton type="submit">
                            {type === 'account' ? 'Save' : 'Next'}
                        </ActionButton>
                    </div>
                </form>
            )}

        </div>
    );
};

export default ContactForm;